import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {GoogleLoginComponent} from './google-login.component';

@NgModule({
  declarations: [GoogleLoginComponent],
  imports: [
    CommonModule
  ],
  exports: [GoogleLoginComponent]
})
export class  GoogleLoginModule {
}
